import React from "react"
import SelectInput from "@components/inputs/SelectInput"
import { PopularBuild, VehicleSectionProps } from "./types"
import {
  SectionContainer,
  Filters,
  Filter,
  BuildButton,
  PopularBuildsContainer,
  PopularBuildsLabel,
  PopularBuildButton,
} from "./styles"

const VehicleSection: React.FC<VehicleSectionProps> = ({
  title,
  variant,
  makes,
  models,
  trims = [],
  years,
  selectedMake,
  selectedModel,
  selectedTrim,
  selectedYear,
  onSelectMake,
  onSelectModel,
  onSelectTrim,
  onSelectYear,
  onBuild,
  popularBuilds = [],
  onPopularBuildClick,
  loading = false,
  catalogLoading = false,
  showPopularBuilds = true,
}) => {
  const isBuildDisabled =
    loading ||
    !selectedMake ||
    !selectedModel ||
    (trims.length > 0 && !selectedTrim) ||
    !selectedYear

  return (
    <SectionContainer>
      {/* <SectionTitle>{title}</SectionTitle> */}
      <Filters>
        <Filter disabled={catalogLoading}>
          <SelectInput
            name={`${variant}-Make`}
            label="Make"
            value={selectedMake}
            options={makes}
            onChange={(e) => {
              onSelectMake(e.target.value)
            }}
          />
        </Filter>
        <Filter disabled={catalogLoading || !selectedMake}>
          <SelectInput
            name={`${variant}-Model`}
            label="Model"
            value={selectedModel}
            options={models}
            onChange={(e) => {
              onSelectModel(e.target.value)
            }}
          />
        </Filter>
        {trims && trims.length > 0 && (
          <Filter disabled={catalogLoading || !selectedMake || !selectedModel}>
            <SelectInput
              name={`${variant}-Trim`}
              label="Trim"
              value={selectedTrim || ""}
              options={trims}
              onChange={(e) => {
                onSelectTrim?.(e.target.value)
              }}
            />
          </Filter>
        )}
        <Filter
          disabled={
            catalogLoading ||
            !selectedMake ||
            !selectedModel ||
            (trims.length > 0 && !selectedTrim)
          }
        >
          <SelectInput
            name={`${variant}-Year`}
            label="Year"
            value={selectedYear}
            options={years}
            onChange={(e) => {
              onSelectYear(e.target.value)
            }}
          />
        </Filter>
        <div className="flex items-center gap-2">
          <BuildButton disabled={isBuildDisabled} onClick={onBuild}>
            {loading ? "Loading..." : "Build"}
          </BuildButton>
          {catalogLoading ? (
            <div
              className="animate-spin h-5 w-5 border-2 border-gray-400 border-t-transparent rounded-full shrink-0"
              aria-label="Loading vehicles"
            />
          ) : null}
        </div>
      </Filters>
      {showPopularBuilds === true && popularBuilds.length > 0 && (
        <PopularBuildsContainer>
          <PopularBuildsLabel>
            Popular {variant === "classic" ? "classic" : "modern"} builds:
          </PopularBuildsLabel>
          {popularBuilds.map((build, index) => (
            <PopularBuildButton
              key={index}
              variant={variant}
              onClick={() => onPopularBuildClick?.(build)}
            >
              {build.label}
            </PopularBuildButton>
          ))}
        </PopularBuildsContainer>
      )}
    </SectionContainer>
  )
}

export default VehicleSection
